// TODO: #646 refactor -- export from index; rename the folder

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { personType } from '@reducers/conference';
import { Button, H2 } from '@atoms';
import { Person } from '@molecules';
import messages from './messages';
import { PersonTableHead } from './PersonTableHead';
import { FlexContainer } from '@layout';

class PeopleList extends Component {
  render() {
    return (
      <div>
        <H2>
          <FlexContainer gap="1rem" style={{ alignItems: 'center' }}>
            {this.props.header}
            <Button id="new-person" onClick={this.props.addPerson} small primary>
              <FormattedMessage {...messages.addPerson} />
            </Button>
          </FlexContainer>
        </H2>
        <PersonTableHead {...this.props} />
        <div id="people-container">{this.props.children}</div>
      </div>
    );
  }
}

export class People extends Component {
  render() {
    const people = this.props.people.map((person, index) => (
      <Person
        key={index}
        id={index}
        person={person}
        setPersonField={this.props.setPersonField}
        removePerson={this.props.removePerson}
        conferenceHasBeenFinished={this.props.conferenceHasBeenFinished}
        numbersByCountries={this.props.numbersByCountries}
        readOnly={person.readOnly}
        {...this.props}
      />
    ));

    return (
      <PeopleList addPerson={this.props.addPerson} {...this.props}>
        {people}
      </PeopleList>
    );
  }
}

People.propTypes = {
  people: PropTypes.arrayOf(personType),
  addPerson: PropTypes.func,
  removePerson: PropTypes.func.isRequired,
  setPersonField: PropTypes.func.isRequired,
};

export default People;



// WEBPACK FOOTER //
// ./components/organisms/people/People.js